export { OnboardingHeader, getOnboardingHeaderHeight } from './OnboardingHeader';
